<template>
    <div class="SomeTalkOfOurClients">
      <section class="container-fluid clients text-white">
    <div class="container text-center">
      <h2 class="pt-5">SOME TALK OF OUR CLIENTS</h2>
      <div class="m-5">
        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">
            <!-- Slider 1 -->
            <div class="carousel-item active">
              <div class="row justify-content-center pt-5">
                <div class="col-lg-6 col-12">
                  <div class="card-wrapper mt-5">
                    <div id="card-1" class="card card-rotating text-center">
                      <!-- Content -->
                      <div class="card-body mb-4">
                        <!-- Avatar -->
                        <img src="../assets/img/marie.jpg" class="avatar position-absolute rounded-circle img-fluid w-25"
                          alt="Marie">
                        <h6 class="mt-5 mb-3 text-uppercase">Marie Johnson</h6>
                        <p>Web developer</p>
                        <p class="text-left px-3 talk">Lorem Ipsum is simply dummy text of the printing and typesetting
                          industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,good.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="card-wrapper mt-5">
                    <div id="card-1" class="card card-rotating text-center">
                      <!-- Content -->
                      <div class="card-body mb-4">
                        <!-- Avatar -->
                        <img src="../assets/img/oliver.png" class="avatar position-absolute rounded-circle img-fluid w-25"
                          alt="Oliver">
                        <h6 class="mt-5 mb-3 text-uppercase">OLIVER GOMEZ</h6>
                        <p>CEO of google</p>
                        <p class="text-left px-3 talk">Lorem Ipsum is simply dummy text of the printing and typesetting
                          industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,good.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <!-- Slider 2 -->
            <div class="carousel-item">
              <div class="row justify-content-center pt-5">
                <div class="col-lg-6 col-12">
                  <div class="card-wrapper mt-5">
                    <div id="card-1" class="card card-rotating text-center">
                      <!-- Content -->
                      <div class="card-body mb-4">
                        <!-- Avatar -->
                        <img src="../assets/img/rita.png" class="avatar position-absolute rounded-circle img-fluid w-25"
                          alt="Rita">
                        <h6 class="mt-5 mb-3 text-uppercase">RITA WATSON</h6>
                        <p>Web designer</p>
                        <p class="text-left px-3 talk">Lorem Ipsum is simply dummy text of the printing and typesetting
                          industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,good.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="card-wrapper mt-5">
                    <div id="card-1" class="card card-rotating text-center">
                      <!-- Content -->
                      <div class="card-body mb-4">
                        <!-- Avatar -->
                        <img src="../assets/img/kate.jpg" class="avatar position-absolute rounded-circle img-fluid w-25"
                          alt="Kate">
                        <h6 class="mt-5 mb-3 text-uppercase">Kate Anderson</h6>
                        <p>Web developer</p>
                        <p class="text-left px-3 talk">Lorem Ipsum is simply dummy text of the printing and typesetting
                          industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,good.
                        </p>
                      </div>
                    </div>
                  </div>
  
                </div>
              </div>
            </div>
  
            <!-- Slider 3 -->
            <div class="carousel-item">
              <div class="row justify-content-center pt-5">
                <div class="col-lg-6 col-12">
                  <div class="card-wrapper mt-5">
                    <div id="card-1" class="card card-rotating text-center">
                      <!-- Content -->
                      <div class="card-body mb-4">
                        <!-- Avatar -->
                        <img src="../assets/img/ema.jpg" class="avatar position-absolute rounded-circle img-fluid w-25"
                          alt="Ema">
                        <h6 class="mt-5 mb-3 text-uppercase">Ema Doe</h6>
                        <p>Web Developer</p>
                        <p class="text-left px-3 talk">Lorem Ipsum is simply dummy text of the printing and typesetting
                          industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,good.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="card-wrapper mt-5">
                    <div id="card-1" class="card card-rotating text-center">
                      <!-- Content -->
                      <div class="card-body mb-4">
                        <!-- Avatar -->
                        <img src="../assets/img/marie.jpg" class="avatar position-absolute rounded-circle img-fluid w-25"
                          alt="Marie">
                        <h6 class="mt-5 mb-3 text-uppercase">Marie Johnson</h6>
                        <p>Web developer</p>
                        <p class="text-left px-3 talk">Lorem Ipsum is simply dummy text of the printing and typesetting
                          industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,good.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
          </div>
          <div class="m-5">
            <ol class="carousel-indicators pb-5">
              <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
            </ol>
          </div>
  
        </div>
      </div>
  
    </div>
  </section>
        
    </div>
</template>

<script>
export default {
  name: 'SomeTalkOfOurClients',
  
}

</script>

<style scoped>

@import '../style.css';


.clients {
    background-image: url('../assets/img/Rectangle\ 3.png');
}
.card {
    background-color: transparent;
    border: none;
}

.card-body {
    border: 1px solid white;
    padding-top: 10%;
}

.avatar {
    top: -17%;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
}

.carousel-indicators li {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #f7f7f7;
}

.carousel-indicators {
    position: relative;
}

.talk {
    font-size: 0.9375rem;
    line-height: 1.625rem;
}
@media (max-width: 575.98px) {
    .avatar {
        top: -10%;
    }
}

@media (max-width: 320px) {
    .avatar {
        top: -5%;
    }
}


</style>